module.exports = __webpack_public_path__ + "static/media/lock.4a9e20c1.svg";